<section class="actualite-container mt-5">
    <div class="container">
      <div class="builder-container">
        <h2 class="title">{{actualite.title}}</h2>
        <div class="datePublished">{{actualite.published_at | date: 'medium'}}</div>

        <div class="diaporama">
          <ngx-slick-carousel class="carousel intro-carrousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of sliders" class="slide">
              <div *ngIf="slide.startsWith('https://www.youtube.com')">
                <iframe width="100%" height="315" [src]="sanitized(slide)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
              <div *ngIf="!slide.startsWith('https://www.youtube.com')">
                <img class="img-slide" src="{{slide}}">
              </div>
            </div>
          </ngx-slick-carousel>
        </div>

        <div class="description" [innerHTML]="actualite.description"></div>

        <div class="liens">
          <div class="downloads" *ngIf="actualite.attachment">
            <p>Téléchargement</p>
                <a href="{{actualite.attachment}}">{{actualite.attachment}}</a>
          </div>

          <div class="url" *ngIf="url.length > 0">
              <p>En savoir plus :</p>
              <div *ngFor="let link of url">
                  <a href="{{link}}">{{link}}</a>
              </div>
          </div>
        </div>
      </div>

      <div class="form-container">
        <div class="col-lg-4 mt-lg-0 mt-3">
          <div class="filter p-5 ">
            <p class="py-2 pt-4">Filtrer les résultats par :</p>
            <form [formGroup]="categorieForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <label class="mb-3">Catégorie :</label>
                <div>
                  <select class="d-block w-100" formControlName="categorie">
                    <option value="" disabled selected>Selectionnez une catégorie</option>
                    <option *ngFor="let tag of tags" value="{{tag.id}}">{{tag.nom}}</option>
                  </select>
                </div>
                <div>
                  <button type="submit" class="btn btn-dark d-block w-100 my-4">Valider</button>
                  <button (click)="openPopUpPage('actualite')" class="btn btn-outline-dark d-block w-100">PROPOSER UNE ACTUALITÉ</button>
                </div>
              </div>
            </form>
          </div>
          <img class="img-fluid mt-5 d-none d-lg-block" src="assets/icons/element-graphique-point.svg" />
        </div>
      </div>

    </div>
  </section>
